import { subDays, subMonths, subYears, endOfDay, startOfDay } from 'date-fns'
import { type DateRangeValue } from '@/features/account/components/BusinessToolsPage/ExportReceipts/types'
import { getItem, removeItem, setItem } from '@/features/shared/utils/localStorage'

export const BUSINESS_PROFILE_CREATED_STORAGE_KEY = 's.bpc'

/**
 * Breadcrumb dropped when a business profile is created so the destination page
 * (currently the global homepage) can show a confirmation modal after navigation.
 */
export const setBusinessProfileCreated = () => {
  setItem(BUSINESS_PROFILE_CREATED_STORAGE_KEY, 'true')
}

/** Returns whether the breadcrumb was set, clearing it so the modal only shows once. */
export const consumeBusinessProfileCreated = () => {
  const wasCreated = getItem(BUSINESS_PROFILE_CREATED_STORAGE_KEY) === 'true'
  if (wasCreated) removeItem(BUSINESS_PROFILE_CREATED_STORAGE_KEY)
  return wasCreated
}

/** Shared by every "date range" filter (order history, spend analytics, etc.) so the
 * meaning of 30d/90d/6mo/1y stays consistent even though each caller formats the
 * resulting bounds differently (ISO datetime vs. plain UTC date). */
export const getDateRangeStart = (range: DateRangeValue, now: Date): Date => {
  switch (range) {
    case '30d':
      return subDays(now, 30)
    case '90d':
      return subDays(now, 90)
    case '6mo':
      return subMonths(now, 6)
    case '1y':
      return subYears(now, 1)
  }
}

export const getDateRangeForBusinessOrderHistory = (
  range: DateRangeValue,
): { startDate: string; endDate: string } => {
  const now = new Date()
  return {
    startDate: startOfDay(getDateRangeStart(range, now)).toISOString(),
    endDate: endOfDay(now).toISOString(),
  }
}
